var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('m-header', {
    attrs: {
      "title": "Neue Schadenmeldung erstellen",
      "breadCrumbs": _vm.breadCrumbs
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "fill-height",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('v-card', {
    attrs: {
      "outlined": "",
      "flat": ""
    }
  }, [_c('partner-report-create-form', {
    on: {
      "submit": _vm.submit
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }